/* eslint-disable react/no-array-index-key */
import React from 'react';

import { Box, Skeleton, Stack } from '@mui/material';

import { COLOR } from '../../../helpers/colors';

const textBox = index => (
  <Skeleton
    key={index.toString()}
    animation="wave"
    variant="text"
    color={COLOR.PH}
    sx={{
      width: '25%',
    }}
  />
);

const CustomerTablePlaceholder = props => (
  <Box
    sx={{
      mt: 2,
      border: `1px solid ${COLOR.borderColor}`,
      borderRadius: 1,
    }}
  >
    <Stack direction="row" justifyContent="space-between" sx={{ m: 2 }}>
      {props.columns.map((c, index) => (
        <Skeleton
          key={index.toString()}
          animation="wave"
          variant="rectangular"
          color={COLOR.PH}
          sx={{
            width: 20,
            height: 20,
          }}
        />
      ))}
    </Stack>
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={8}
      sx={{ borderBottom: `1px solid ${COLOR.borderColor}`, p: 2 }}
    >
      {props.columns.map((c, dIndex) => textBox(dIndex))}
    </Stack>
    {[0, 1, 2, 3].map((d, index) => (
      <Stack
        key={index.toString()}
        direction="row"
        justifyContent="space-between"
        spacing={8}
        sx={{ p: 2 }}
      >
        {props.columns.map((c, cIndex) => textBox(cIndex))}
      </Stack>
    ))}
  </Box>
);

export default CustomerTablePlaceholder;
